module.exports = __webpack_public_path__ + "f85d62fa729bf3612c07bccba04c110b.png";